import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

import Home from './Components/Pages/Home';
import VideoPlay from './Components/Pages/VideoPlay';
import Navbar from './Components/Navbar';
import Sidebar from './Components/Sidebar';
import Login from './Components/LoginPage/Login';
import Profile from './Components/UserProfile/Profile';
import EditProfile from './Components/UserProfile/EditProfile';
import VideoUploading from './Components/UploadingVideo/VideoUploading';
import History from './Components/UserProfile/History';
import MyVideo from './Components/UserProfile/MyVideo';
import { SearchProvider } from './Components/SearchContext';
import Information from './Components/Pages/Information';
import PhotoUploading from './Components/UploadingVideo/PhotoUploading';
import Gift from './Components/Pages/Gift'; 
import Editing from './Components/UploadingVideo/Editing'; 
import Task from './Components/Pages/Task'; // Assuming you have a Task component
import Playlist from './Components/Pages/Playlist';
import Commission from './Components/Pages/Commission';
import GoogleSearch from './Components/Pages/GoogleSearch';
import Instruction from './Components/Admin/Instruction';
import Setting from './Components/UserProfile/Setting'
import Invite from './Components/UserProfile/Invite'; // Importing the Invite component
import Photoshow from './Components/UploadingVideo/Photoshow';

import Adminprofile from './Components/Admin/Adminprofile'; // Importing Adminprofile component
import Videoads from './Components/Admin/Videoads';
import Dashboard from './Components/Admin/Dashboard';
import UserProfile from './Components/Admin/UserProfile';
import ShowlikeUnlikeusers from './Components/Admin/ShowlikeUnlikeusers';


function App() {
  const location = useLocation();
  const [isAdmin, setIsAdmin] = useState(false);
  const isInformationPage = location.pathname === '/' || location.pathname === '/login' || location.pathname === '/edit-profile';

  useEffect(() => {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const isAdminRoute = location.pathname.startsWith('/admin/');
    setIsAdmin(currentUser?.username === 'admin' && isAdminRoute);
  }, [location.pathname]);

  return (
    <SearchProvider>
      <div className="">
        {/* Sidebar - Hidden for admin routes and Information page */}
        {!isAdmin && !isInformationPage && (
          <div>
            <Sidebar />
          </div>
        )}
        {/* Main content area */}
        <div >
          {/* Navbar - Hidden for admin routes and Information page */}
          {!isAdmin && !isInformationPage && (
            <div>
              <Navbar />
            </div>
          )}
          <div className={isAdmin || isInformationPage ? 'p-0' : 'md:ml-64 pt-16 pb-16'}>
            <Routes>
              {/* Public Routes */}
              <Route path="/home" element={<Home />} />
              <Route path="/" element={<Information />} />
              <Route path="/upload" element={<VideoUploading />} />
              <Route path="/login" element={<Login />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/edit-profile" element={<EditProfile />} />
              <Route path="/video/:videoId" element={<VideoPlay />} />
              <Route path="/my-videos" element={<MyVideo />} />
              <Route path="/history" element={<History />} />         
              <Route path="/photo-upload" element={<PhotoUploading />} />
              <Route path="/edit/:id" element={<Editing />} />
              <Route path="/gift" element={<Gift />} />
              <Route path="/task" element={<Task />} />
              <Route path="/playlist" element={<Playlist />} />
              <Route path="/commission" element={<Commission />} />
              <Route path="/google" element={<GoogleSearch />} />          
              <Route path='/setting' element={<Setting/>} />
              <Route path="/invite" element={<Invite />} />
              <Route path="/photoshow/:photoId" element={<Photoshow />} />

              {/* Admin Routes */}
              <Route path="/admin/profile" element={<Adminprofile />} />           
              <Route path="/admin/videoads" element={<Videoads />} />
              <Route path="/admin/dashboard" element={<Dashboard />} />
              <Route path="/admin/user/:userId" element={<UserProfile />} />
              <Route path="/admin/showlikeunlikeusers" element={<ShowlikeUnlikeusers />} />
              <Route path="/admin/instruction" element={<Instruction />} />
            
            </Routes>
          </div>
        </div>
      </div>
    </SearchProvider>
  );
}

function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default AppWrapper;